/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch, useSelector } from 'react-redux';
import style from './DoctorDetails.module.scss';
import classNames from 'classnames/bind';
import { setdoctorFreeDates, setdoctorFreeSlots } from '../doctorsSlice';
import { Button, Segment, Tab } from 'semantic-ui-react';
import DoctorInfoAppointments from './doctorInfoAppointments';
import DoctorInfoAbsences from './doctorAbsenses/doctorInfoAbsences';
import { globalSliceSelector } from '../../../app/appSlice';
const cx = classNames.bind(style);

export function DoctorInfoComponent(props: { selectedDoctor: any; onBack: () => void }) {
  const { selectedDoctor, onBack } = props;
  const doctorsClasses = cx({ DoctorStats: true });
  const { language } = useSelector(globalSliceSelector);
  const dispatch = useDispatch();

  if (!selectedDoctor || !selectedDoctor.id) {
    return (
      <Segment raised inverted className='segment-style'>
        No doctor selected. Please go back and select a doctor.
      </Segment>
    );
  }

  const menuEng = 'Available Appointments';
  const menuGer = 'Verfügbare Termine';
  const menu1Eng = 'Absences';
  const menu1Ger = 'Abwesenheiten';

  const onBackButton = () => {
    onBack();
    dispatch(setdoctorFreeDates([]));
    dispatch(setdoctorFreeSlots([]));
  };

  const panes = [
    {
      menuItem: `${language === 'en' ? menuEng : menuGer}`,
      render: () => (
        <Tab.Pane className='list-doctor-appointment'>
          <DoctorInfoAppointments doctorId={selectedDoctor.id} menuText={language === 'en' ? menuEng : menuGer} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: `${language === 'en' ? menu1Eng : menu1Ger}`,
      render: () => (
        <Tab.Pane>
          <DoctorInfoAbsences doctorId={selectedDoctor.id} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <main className={doctorsClasses}>
      <Button onClick={() => onBackButton()} circular basic icon='arrow left' />
      <Segment raised inverted className='segment-style'>
        <article className={style.RowContainer}>
          <div className={style.DoctorTitleRowContainer}>
            <p>ID:</p>
            <p>{selectedDoctor.id}</p>
          </div>
          <div className={style.DoctorTitleRowContainer}>
            <p>Name:</p>
            <p>
              {/* FIX 1: Construct the name from firstname and lastname */}
              <b>{`${selectedDoctor.firstname} ${selectedDoctor.lastname}`}</b>
            </p>
          </div>
          <div className={style.DoctorTitleRowContainer}>
            <p>E-mail:</p>
            <p>{selectedDoctor.email}</p>
          </div>
        </article>

        {/* FIX 2: Removed the Divider and the entire 'article' block that displayed stats */}
      </Segment>
      <Tab panes={panes} />
    </main>
  );
}
